const endpoint = `${process.env.REACT_APP_BACKEND_URL || ''}/api/security/client-errors`;
let count = 0, windowStart = 0;
const names = new Set(['Error','TypeError','ReferenceError','RangeError','SyntaxError','URIError','EvalError']);
const roots = new Set(['login','users','user','vehicles','vehicle','drivers','driver','map','fleet','reports','new-report','fleet-reports','new-fleet-report','security','notifications','connection','sites','pois','devices','device','groupevehicles','group-driver','alarms','group-alarms','geofence-checker','position-tracking','tickets','help']);
export function safePage(path: string) {
  if (path === '/') return '/';
  const parts = path.split('/').filter(Boolean), root = (parts[0] || '').toLowerCase();
  return roots.has(root) ? '/' + root + parts.slice(1,5).map(value => ['add','edit','live'].includes(value) ? '/' + value : '/:value').join('') : '/other';
}
export function reportSecurityError(kind: string, error: unknown) {
  if (Date.now() - windowStart > 60000) {count = 0; windowStart = Date.now();}
  if (count >= 10) return;
  count++;
  // No exception message, stack, URL query, cookies, token or form field is transmitted.
  const name = error instanceof Error && names.has(error.name) ? error.name : 'Error';
  void fetch(endpoint, {method:'POST',credentials:'include',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({kind,name,page:safePage(window.location.pathname)})}).catch(()=>{});
}
export function installSecurityErrorReporting() {
  const onError = (event: ErrorEvent) => reportSecurityError('javascript_error',event.error);
  const onRejection = (event: PromiseRejectionEvent) => reportSecurityError('unhandled_rejection',event.reason);
  window.addEventListener('error',onError);
  window.addEventListener('unhandledrejection',onRejection);
  return () => {window.removeEventListener('error',onError);window.removeEventListener('unhandledrejection',onRejection);};
}
